const fulfillmentConfigurations = new WeakMap();

function fulfillmentProductId(value) {
  if (typeof value === 'number' && (!Number.isSafeInteger(value) || value <= 0)) return null;
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  const id = String(value);
  return /^[1-9]\d*$/.test(id) ? id : null;
}

function fulfillmentConfiguration(root) {
  if (fulfillmentConfigurations.has(root)) return fulfillmentConfigurations.get(root);
  const data = root.querySelector('[data-ep-cart-fulfillment-data]');
  if (!data) return null;

  try {
    const parsed = JSON.parse(data.textContent);
    if (!Array.isArray(parsed.freightProductIds) || !Array.isArray(parsed.groundProductIds)) return null;
    const configuration = {
      freight: new Set(parsed.freightProductIds.map(fulfillmentProductId).filter(Boolean)),
      ground: new Set(parsed.groundProductIds.map(fulfillmentProductId).filter(Boolean)),
    };
    fulfillmentConfigurations.set(root, configuration);
    return configuration;
  } catch (error) {
    return null;
  }
}

window.addEventListener('cartcount:update', event => {
  const items = event.detail && event.detail.items;
  if (!Array.isArray(items)) return;

  const productIds = new Set();
  for (const item of items) {
    if (!item || typeof item !== 'object') return;
    const productId = fulfillmentProductId(item.product_id);
    if (!productId) return;
    if (item.quantity !== undefined && (!Number.isSafeInteger(item.quantity) || item.quantity < 0)) return;
    if (item.quantity !== 0) productIds.add(productId);
  }

  document.querySelectorAll('[data-ep-cart-fulfillment]').forEach(root => {
    const configuration = fulfillmentConfiguration(root);
    if (!configuration) return;

    const hasFreight = [...productIds].some(id => configuration.freight.has(id));
    const hasGround = [...productIds].some(id => configuration.ground.has(id));
    const visible = {
      notice: hasFreight || hasGround,
      freight: hasFreight,
      ground: hasGround,
      calculator: productIds.size > 0 && !hasFreight,
    };

    root.querySelectorAll('[data-ep-cart-state]').forEach(element => {
      const state = element.dataset.epCartState;
      if (typeof visible[state] === 'boolean') element.hidden = !visible[state];
    });
  });
});
